module.exports = __webpack_public_path__ + "img/sms.4fbfc10.png";